export const QUERY_MONITOR_SETTINGS_ITEM = "QUERY_MONITOR_SETTINGS_ITEM";
